import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from "utils/axios";
import { ROUTE_API } from 'configs';
import { dispatch } from 'store';
import { DefaultRootStateProps } from 'types';


const initialState: DefaultRootStateProps['stores'] = {
    listType: [],
    selectedStore: undefined,
    loading: false,
    error: null,
};

const slice = createSlice({
    name: 'stores',
    initialState,
    reducers: {
        setSelectedStore: (state, action: PayloadAction<number | string | undefined>) => {
            state.selectedStore = action.payload;
        },
        setListType: (state, action: any) => {
            state.listType = action.payload;
        },
    },

});
export function getList(not_ho: boolean) {
    return async () => {
        try {
            const params = {
                page: 1,
                perpage: 1000,
                not_ho,
            };
            const response = await axios.get(ROUTE_API.store.publicStoreList, { params, headers: { isShowLoading: false } });
            const { Data } = response.data;
            dispatch(slice.actions.setListType(Data.data ?? []));
        } catch (error) {
            // dispatch(slice.actions.hasError(error));
        }
    };
}
export const { setSelectedStore } = slice.actions;

export default slice.reducer;

